import { FirebaseApp, initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { fetchAndActivate, getRemoteConfig } from "firebase/remote-config";
import { getAnalytics } from "firebase/analytics";
import {
  Auth,
  initializeAuth,
  debugErrorMap,
  indexedDBLocalPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import Config from "@/config/Config";

// Debug logging to see what config is being used
console.log('Firebase Config being used:', Config.FirebaseConfig);
console.log('Project ID:', Config.FirebaseConfig.projectId);

export const app: FirebaseApp = initializeApp(Config.FirebaseConfig);

// getAnalytics(app);
export const auth: Auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence],
  errorMap: debugErrorMap,
});

export const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 300000; // Only fetch once every 5 minutes

// fetchAndActivate(remoteConfig)
//   .then(() => {
//     console.log("config fetched and activated");
//   })
//   .catch((error) => {
//     console.error(error);
//   });
